export const checkHasUp = (pc_id) => $.get('/@api/ups/check_has_up', { pc_id });
